import React from 'react';
import { Lock } from 'lucide-react';

export const LiveLock = ({ locked, children }) => {
  if (!locked) return children;
  return (
    <div data-testid="live-content-lock">
      <div className="mb-4 flex items-center gap-2 rounded-xl border border-slate-300 bg-slate-50 px-4 py-3 text-slate-700 text-sm font-bold">
        <Lock className="w-4 h-4 shrink-0" />
        للقراءة فقط: تعديل المحتوى يتم من المعاينة، ثم يُنشر من صفحة «النشر» والضغط على Deploy.
      </div>
      <fieldset disabled className="opacity-80">{children}</fieldset>
    </div>
  );
};
